import { render, staticRenderFns } from "./PrivacyCopy.vue?vue&type=template&id=2dba8834&scoped=true&"
import script from "./PrivacyCopy.vue?vue&type=script&lang=js&"
export * from "./PrivacyCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dba8834",
  null
  
)

export default component.exports